import { Observable } from "rxjs";
import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { BaseHttpService } from "./base.http.service";
import { ContractType } from "src/app/shared/types/contract-types";
import { CreateContractType } from "src/app/shared/types/create-contract-type";

@Injectable({
  providedIn: "root",
})
export class ContractService extends BaseHttpService {
  constructor(private http: HttpClient) {
    super();
  }

  private apiUrlWithEndpoint(endpoint: string): string {
    return `${this.apiUrl}/api/contracts/${endpoint}`;
  }

  getContract(): Observable<ContractType> {
    return this.http.get<ContractType>(this.apiUrlWithEndpoint("contract"));
  }

  getAllContracts(): Observable<ContractType[]> {
    return this.http.get<ContractType[]>(this.apiUrlWithEndpoint("paginated"));
  }

  createContract(contract: CreateContractType): Observable<CreateContractType> {
    return this.http.post<CreateContractType>(this.apiUrlWithEndpoint("createandapprove"), contract);
  }

  addContract(email: string): Observable<ContractType> {
    return this.http.post<ContractType>(this.apiUrlWithEndpoint(`?email=${encodeURIComponent(email)}`), null);
  }

  deleteContract(contractID: number, deleteCustomer: boolean = true, customerId: number = 0): Observable<ContractType> {
    return this.http.delete<ContractType>(this.apiUrlWithEndpoint(`${contractID}?deleteCustomer=${deleteCustomer}&customerId=${customerId}`));
  }

  getContractById(contractId: number): Observable<ContractType> {
    return this.http.get<ContractType>(this.apiUrlWithEndpoint(`${contractId}`));
  }

  approveContract(contractID: number, name: string, tier: any): Observable<ContractType> {
    return this.http.post<ContractType>(this.apiUrlWithEndpoint(`approve`), {
      contractId: contractID,
      name,
      tier,
    });
  }

  updateSoftware(contractId: number): Observable<any> {
    return this.http.post<number>(this.apiUrlWithEndpoint("updatesoftware"), contractId);
  }

  updateContract(contractID: number, body: ContractType): Observable<ContractType> {
    return this.http.put<ContractType>(this.apiUrlWithEndpoint(`${contractID}`), body);
  }

  importDemoDatabase(contractId: number, file: File): Observable<ContractType> {
    const formData: FormData = new FormData();
    formData.append("import", file);

    return this.http.post<ContractType>(this.apiUrlWithEndpoint(`${contractId}/import`), formData, {
      headers: new HttpHeaders({
        enctype: "multipart/form-data",
      }),
    });
  }

  getContractDbUsers(contractId: number): Observable<string[]> {
    return this.http.get<string[]>(this.apiUrlWithEndpoint(`${contractId}/users`));
  }

  migrateUsersApiKey(contractId: number, emails: string[]): Observable<string> {
    return this.http.put<string>(this.apiUrlWithEndpoint(`${contractId}/migrate-users`), { emails });
  }
}
